var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"cxm-PaginationItemsRange"},[_vm._v("\n  "+_vm._s(_vm.$t('loading'))+"\n")]):_c('div',{staticClass:"cxm-PaginationItemsRange",domProps:{"innerHTML":_vm._s(_vm.$t('range', { startRow: _vm.startRow, endRow: _vm.endRow, totalItems: _vm.totalItems }))}})
}
var staticRenderFns = []

export { render, staticRenderFns }